// extracted by mini-css-extract-plugin
export default {"tab_nav":"tabs_tab_nav__P2S9t","tab":"tabs_tab__oBl1N","active_tab":"tabs_active_tab__wJnDU"};